import type { FC, Ref } from "react";
import { format } from "date-fns";
import { useTranslation } from "react-i18next";

import { Select, type SelectProps } from "../Select/Select";
import type { SelectListOption } from "../SelectList/SelectList";

export type MonthFieldProps = Omit<SelectProps, "options"> & {
  labelVariant?: "full" | "short";
  /**
   * Ref forwarded to the root element
   */
  ref?: Ref<HTMLDivElement>;
};

/**
 * A select field for selecting a month.
 */
export const MonthField: FC<MonthFieldProps> = ({
  labelVariant = "full",
  ref,
  ...props
}) => {
  const { t } = useTranslation();
  const options: SelectListOption[] = Array.from(
    { length: 12 },
    (_, i) => i,
  ).map((monthIndex) => ({
    value: monthIndex,
    label: t(
      `dates.months.${labelVariant}.${format(new Date(2024, monthIndex), "MMM").toLowerCase()}`,
    ),
  }));

  return <Select ref={ref} options={options} {...props} />;
};
